import React from 'react';
import Formsy from 'formsy-react';
import FormsyInput from '../form/FormsyInput';
import { parseUrlParams } from '../../helpers/util';
import withSplashMessage from '../splashMessage/withSplashMessage';
import withUser from './withUser';
import withTracker from '../withTracker';

class PasswordReset extends React.Component {
  defaultState = {
    role: 'client',
    password: '', // password
    password_confirmation: '' // password_confirmation
  };

  state = {
    ...this.defaultState,
    urlParams: this.props.location // TODO get headers from here, put them in local storage
    // TODO Then submit the form, it should work.
  };

  render() {
    const validationErrors = {
      equalsField: 'The passwords do not match.',
      minLength: 'Password must be 8 characters.',
      maxLength: 'Password cannot be 20 characters.'
    };
    return (
      <div className="login">
        <div className="login__wrap">
          <h2 className="login__h1">Sign In</h2>
          <h1 className="login__h2">Reset Password</h1>
          <Formsy
            className="login__form"
            onValidSubmit={this.handleSubmit}
            onInvalidSubmit={this.handleInvalidSubmit}
            onValid={this.handleValid}
            onInvalid={this.handleInvalid}
          >
            <div className="form__row">
              <div className="form__row-item form__row-item--full">
                <FormsyInput
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={this.state.password}
                  onChange={this.handleChange}
                  validations={'minLength:8,maxLength:20'}
                  validationErrors={validationErrors}
                  showValid
                  required
                />
                <p className="p--green-text small">
                  Requires: 1 uppercase, 1 lowercase and 1 number
                </p>
              </div>
            </div>
            <div className="form__row">
              <div className="form__row-item form__row-item--full">
                <FormsyInput
                  type="password"
                  name="password_confirmation"
                  placeholder="Confirm Password"
                  value={this.state.password_confirmation}
                  onChange={this.handleChange}
                  validations={'equalsField:password'}
                  validationErrors={validationErrors}
                  showValid
                  required
                />
              </div>
            </div>

            <div className="form__row">
              <div className="form__row-item form__row-item--full">
                <button
                  type="submit"
                  className="btn btn--solid-blue btn--full-width"
                  disabled={!this.state.isValid}
                >
                  Reset and Sign In
                </button>
              </div>
            </div>
          </Formsy>
        </div>
      </div>
    );
  }

  handleValid = () => this.setState({ isValid: true });
  handleInvalid = () => this.setState({ isValid: false });

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  handleSubmit = (formData, data, errors) => {
    const { search = '?' } = this.props.location;
    const headers = parseUrlParams(search);

    // manually set 'accessToken' from 'access-token'
    const authHeaders = {
      ...headers,
      accessToken: headers['access-token']
    };
    localStorage.setItem('authHeaders', JSON.stringify(authHeaders));

    const { role = 'client' } = this.props.match.params;
    const { password, password_confirmation } = this.state;
    const updatedClient = {
      role,
      password,
      password_confirmation
    };

    this.props.resetPassword(updatedClient);
  };
}

export default withUser(withSplashMessage(withTracker(PasswordReset)));



// WEBPACK FOOTER //
// ./src/components/auth/PasswordReset.js